import React, { useState, useEffect } from "react";
import ServerTable from "./serverTable";

type ClientsResponse = {
  clients: Record<string, { overall_status?: string }>;
};

type Server = {
  id: number;
  name: string;
  status: string;
  displayName: string;
};

const ServerStatus = () => {
  const [devServers, setDevServers] = useState<Server[]>([]);
  const [uatServers, setUatServers] = useState<Server[]>([]);
  const [responseMessage, setResponseMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const transformClients = (apiData: ClientsResponse) => {
    if (!apiData?.clients) return [];

    return Object.entries(apiData.clients).map(
      ([name, value], index) => ({
        id: index + 1,
        name,
        status:
          value.overall_status?.toLowerCase() === "running"
            ? "Running"
            : "Stopped",
        displayName: name,
      })
    );
  };

  const fetchServersByEnv = async (env: string) => {
    const response = await fetch(
      `https://opltpq2hn9.execute-api.us-east-1.amazonaws.com/${env}/status`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch");
    }

    const data = await response.json();
    return transformClients(data);
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setIsLoading(true);

        const envs = ["dev", "uat"];

        const results = await Promise.all(
          envs.map((env) => fetchServersByEnv(env))
        );

        setDevServers(results[0]);
        setUatServers(results[1]);

      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, []);

  return (
    <div className="p-6">
      <div className="h-full bg-gray-50 rounded-lg shadow-lg">
        {responseMessage && <div className="text-md font-bold text-gray-800 p-2 text-right">Response : {responseMessage}</div>}
        <div style={{ "height": "90vh" }} className={`p-4 overflow-auto text-sm text-right ${responseMessage ? "pt-0":""}`} >
          <ServerTable envName="Dev" data={devServers} loading={isLoading} returnMessage={setResponseMessage} />
          <ServerTable envName="UAT" data={uatServers} loading={isLoading} returnMessage={setResponseMessage} />
        </div>
      </div>
    </div>
  );
};

export default ServerStatus;
